<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="modern-header">
                    <div class="container header-content">
                        <button class="btn-voltar" type="button" @click="voltar">Voltar</button>
                        <h1 class="modern-title">{{ nmArquivo || 'Arquivo' }}</h1>
                    </div>
                </div>
                <div class="leitor-body">
                    <p v-if="flCarregando" class="leitor-status">Carregando arquivo…</p>
                    <iframe v-else-if="blobUrl" class="leitor-frame" :src="blobUrl" title="Visualização do arquivo"></iframe>
                    <p v-else class="leitor-status">Não foi possível abrir o arquivo.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import axios from 'axios'
    import { urlApi, avisoErro } from '@/config/global'

    export default {
        name: 'LeitorPdfFerramenta',
        components: { Header },
        data() {
            return {
                flCarregando: false,
                blobUrl: '',
            }
        },
        computed: {
            urlArquivo() {
                return this.$route.query.urlArquivo || ''
            },
            nmArquivo() {
                const partes = String(this.urlArquivo).split('/')
                return decodeURIComponent(partes[partes.length - 1] || '')
            },
        },
        methods: {
            voltar() {
                if (window.history.length > 1) this.$router.go(-1)
                else this.$router.push({ name: 'Pesquisa' })
            },
            liberar() {
                if (this.blobUrl) {
                    window.URL.revokeObjectURL(this.blobUrl)
                    this.blobUrl = ''
                }
            },
            async carregar() {
                this.liberar()
                if (!this.urlArquivo) return
                this.flCarregando = true
                try {
                    const response = await axios({
                        url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${encodeURIComponent(this.urlArquivo)}&nmArquivo=${encodeURIComponent(this.nmArquivo || 'arquivo.pdf')}`,
                        method: 'GET',
                        responseType: 'blob',
                    })
                    const tipo = response.data && response.data.type ? response.data.type : 'application/pdf'
                    this.blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: tipo }))
                } catch (e) {
                    avisoErro('Não foi possível visualizar o arquivo')
                } finally {
                    this.flCarregando = false
                }
            },
        },
        mounted() {
            this.carregar()
        },
        beforeDestroy() {
            this.liberar()
        },
        watch: {
            urlArquivo() {
                this.carregar()
            },
        },
    }
</script>

<style scoped>
    .modern-header {
        background: #111827;
        color: #fff;
        padding: 12px 0;
    }

    .header-content {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .modern-title {
        font-size: 16px;
        font-weight: 700;
        margin: 0;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .btn-voltar {
        border: 1px solid rgba(255, 255, 255, 0.25);
        background: transparent;
        color: #fff;
        border-radius: 8px;
        padding: 6px 12px;
        cursor: pointer;
    }

    .leitor-body { min-height: calc(100vh - 120px); background: #1f2937; }

    .leitor-frame {
        width: 100%;
        height: calc(100vh - 120px);
        border: none;
        display: block;
        background: #fff;
    }

    .leitor-status {
        color: #e5e7eb;
        text-align: center;
        padding: 48px 16px;
    }
</style>
